import { ampli } from 'models/ampli'

import { IdentificationUrlKeys } from '../../types'

export function onQuickFilter(filterParams: object) {
  const filters = {
    'IP address': IdentificationUrlKeys.IpAddress in filterParams,
    URL: IdentificationUrlKeys.Url in filterParams,
    linkedID: IdentificationUrlKeys.LinkedId in filterParams,
    requestID: IdentificationUrlKeys.RequestId in filterParams,
    visitorID: IdentificationUrlKeys.VisitorId in filterParams,
    origin: IdentificationUrlKeys.Origin in filterParams,
    environment: IdentificationUrlKeys.Environment in filterParams,
    highRecallID: IdentificationUrlKeys.HighRecallId in filterParams,
    proximityID: IdentificationUrlKeys.ProximityId in filterParams,
  }

  const setFilters = Object.entries(filters)
    .filter(([_, value]) => value === true)
    .map(([key]) => key as keyof typeof filters)

  ampli.attributeFilterApplied({
    datasetFocus: 'Identification Events',
    attributeFilters: setFilters,
    filterType: 'Magnifying Glass',
  })
}
